// extracted by mini-css-extract-plugin
module.exports = {"root":"html-iframe-view_root__1GP86","frame":"html-iframe-view_frame__xMdNV","frameReadOnly":"html-iframe-view_frameReadOnly__1emx_"};